import React, { useEffect, useState } from "react";
import GeneralBuildingSearchBar from "../../../../shared/components/building_filters/GeneralBuildingSearchBar";
import RecentHistory from "./RecentHistory";
import { TextField, Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextIcon from "mdi-react/FileDocumentOutlineIcon";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr,
} from "../../../../shared/helpers/utils";

import CustomizedSlider from "../../../../shared/components/ai/assistant/FormSlideControl";
import FormAutocompleteSelect from '../../../../shared/components/ai/assistant/FormAutocompleteSelect';
import LinearLoading from "../../../../shared/components/LinearLoading";



const apiURL = process.env.API_ROOT;

const searchBarBuildingStyles = makeStyles((theme) => ({
  appBar: {
	backgroundColor:'#F5F7FA !important',
	transform:'none !important',
	color:'#FFF !important',
	boxShadow:"none",
	padding: 'none !important',
	"& .MuiToolbar-gutters": {
	  paddingRight: "0px !important",
	  paddingLeft: "0px !important",
	},
  },
  grow: {
	flexGrow: 1,
  },
  menuButton: {
	marginRight: theme.spacing(2),
  },
  title: {
	display: 'none',
	[theme.breakpoints.up('sm')]: {
	  display: 'block',
	},
  },
  search: {
	position: "relative",
	borderRadius: theme.shape.borderRadius,
	backgroundColor: " #FFF !important",
	border:"2px solid #333",
	marginRight: "0px !important",
	marginLeft: "0px !important",
	width: "100%",
	padding:"2px 0",
	[theme.breakpoints.up("sm")]: {
	  marginLeft: 0,
	  width: "100%",
	  maxWidth: "none",
	},
	"& .c_search-result-container": {
	  boxShadow:"none",
	  top:"50px"
	},
	"& .c_input-tag": {
	  background: "#A3ADC2",
	  color: "#FFF",
	  "& .mdi-icon": {
		fill: "#FFF",
	  },
	},
	"& .poly_map_launcher": {
	  background: "#5C1F7A !important",
	},
	"&.MuiToolbar-gutters": {
	  paddingRight: 0,
	},
	"& .mdi-icon": {
	  fill: "#A3ADC2",
	},
	"& .c_clear-search" :{
	  color:"#780F9E"
	},
	"& .c_search-nav": {
	  color: "#A3ADC2",
	  "& .c_nav-input.MuiInputBase-input": {
		color: "#A3ADC2",
	  },
	},
  },
  searchIcon: {
	width: theme.spacing(7),
	height: "100%",
	position: "absolute",
	pointerEvents: "none",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
  },
  inputInput: {
	borderRadius: theme.shape.borderRadius,
	backgroundColor: " #FFF !important",
	width:"150px !important",
	padding:"16px !important"
  },
  inputInputLong: {
	  borderRadius: theme.shape.borderRadius,
	  backgroundColor: " #FFF !important",
	  padding:"16px !important",
	  width:"200px !important",
	},
  inputRoot: {
	color: 'inherit',
	width: '100%',
	border: 0,
	'&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
	  padding:0
	},
	
  },
  outlinedTextField: {
	"&.MuiOutlinedInput-root": {
	  "& fieldset": {
		border: "2px solid #333",
	  },
	  "&:hover fieldset": {
		border: "2px solid #000",
	  },
	  "&.Mui-focused fieldset": {
		border: "2px solid #333",
	  },
	  
	},
	'&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
	  padding:1,
	  background:"#FFF"
	}
  },
  sectionDesktop: {
	display: 'none',
	[theme.breakpoints.up('md')]: {
	  display: 'flex',
	},
  },
  sectionMobile: {
	display: 'flex',
	[theme.breakpoints.up('md')]: {
	  display: 'none',
	},
  },
  searchButton: {
	color: "#FFF",
	borderColor: "#FFF",
	backgroundColor: "#5C1F7A",
	margin: "0px 5px",
	padding:"5px 12px",
	"&:hover": {
	  borderColor: "#FFF",
	  backgroundColor: "#B070CC",
	},
	height: 50,
	boxShadow:
	  "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
	"&.Mui-disabled": {
	  boxShadow: "none",
	  color: "#A3ADC2",
	  backgroundColor:"#DBE0E8",
	},
  },
  resetButton: {
	color: "#5C1F7A",
	borderColor: "#5C1F7A",
	backgroundColor: "#FFF",
	margin: "0px 5px",
	padding:"5px 20px",
	"&:hover": {
	  borderColor: "#FFF",
	  backgroundColor: "#B070CC",
	},
	height: 50,
	boxShadow:
	  "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
	"&.Mui-disabled": {
	  boxShadow: "none",
	  color: "#9600BF",
	},
  },
}));
function formatCurrencyLive(value, prefix="$") {
  if (!value) return "";
  // Ensure the value is a string
  value = value.toString();
  
  // Split the value on the decimal point.
  const parts = value.split(".");
  // Format the integer part using toLocaleString.
  const intPart = parts[0] ? parseInt(parts[0], 10) : 0;
  const formattedInt = isNaN(intPart) ? "" : intPart.toLocaleString("en-US");
  
  let result = prefix + formattedInt;
  
  // If the user has typed a decimal point, append it and any following digits.
  if (value.includes(".")) {
	result += ".";
	if (parts[1]) {
	  result += parts[1];
	}
  }
  return result;
}
const wordMarks = [
   {
	 value: 200,
	 label: "200"
   },
   {
	 value: 250,
	 
   },
   {
	   value: 300,
	   label: "300"
	 },
	 {
	   value: 350,
	 },
	 {
	   value: 400,
	   label: "400"
	 },
	 {
	   value: 450,
	 },
	 {
	   value: 500,
	   label: "500"
	 },
	 {
	   value: 550,
	 },
	 {
	   value: 600,
	   label: "600"
	 },
 ];

function ToneSelector({ value, onChange }) {
  return (
	<div className="tone-container">
	  <div className="material-form__label bold-text">Tone</div>
	  <div className="material-form__label">Adjust the tone of the description</div>
	  <RadioGroup
		name="tone"
		value={value}
		onChange={(e) => onChange(e.target.value)}
		onClick={(e) => e.stopPropagation()}
		row
	  >
		<FormControlLabel value="professional" control={<Radio />} label="Professional" />
		<FormControlLabel value="neutral" control={<Radio />} label="Neutral" />
		<FormControlLabel value="casual" control={<Radio />} label="Casual" />
	  </RadioGroup>
	</div>
  );
}

function LengthSlider({ value, onChange }) {
  return (
	<div className="listing-desc-container">
	<CustomizedSlider
	  value={value}
	  onChange={onChange}
	  label={`Length (${value} Words)`}
	  helperText="Adjust the length of the description"
	  defaultVal={value ? value : 400}
	  max={600}
	  min={200}
	  marks={wordMarks}
	/>
	</div>
  );
}


export default function ListingDescSelector(props) {
  const { updateBuildingReport, searchTags, clearTags, compSettings, setCompSettings, reportItem } = props;
  console.log(compSettings);
  const classes = searchBarBuildingStyles();

  const [selectedBuilding, setSelectedBuilding] = useState(compSettings.selectedBuilding ? compSettings.selectedBuilding : null);
  const [units, setUnits] = useState(false);
  const [building, setBuilding] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(compSettings.selectedUnit ? compSettings.selectedUnit : null);
  const [userAddedUnit, setUserAddedUnit] = useState(null);
  const [priceFocused, setPriceFocused] = useState(false);
  const [listing, setListing] = useState(null);
  const [buildingListing, setBuildingListing] = useState(null);
  const [descSettings, setDescSettings] = useState({
	tone: "neutral",
	length: 400,
  });
  const [aiExtractionProgress, setAIExtractionProgress] = useState(true);
  
  const defaultPropertyDetails = {
	  bedrooms: "",
	  baths: "",
	  sq_ft: "",
	  customPrice: "",
	  monthlyCC: "",
	  monthlyTax: "",
	  key: "",
	  floor: "",
	  property: null,
	  images: [],
	  tone: "neutral",
	  length: 400,
	  highlights:false
	}

  const [propertyDetails, setPropertyDetails] = useState(compSettings.propertyDetails ? compSettings.propertyDetails : defaultPropertyDetails);
  
  const handleBuildingSelect = (building) => {
	console.log(building);
	setSelectedBuilding(building);
	if (building && building.key) {
	  fetchUnits(building.key);
	} else {
	  // if(!isHouse){
	  //  setUnits([]);
	  // }
	}
  };
  
  const handleUnitSelect = (unit) => {
	console.log(unit);
	if (!unit) {
	  reset();
	}
	
	let theUnit = units && units.filter(item => 
	  (unit && item && item.address_2_normalized && item.address_2_normalized.toLowerCase() === unit.toLowerCase())
	).length > 0 ? units.filter(item => 
	  (unit && item && item.address_2_normalized && item.address_2_normalized.toLowerCase() === unit.toLowerCase())
	)[0] : false;
	setSelectedUnit(unit);
	setDetailsFromUnit(theUnit, setPropertyDetails);
	
	setUserAddedUnit(null);
  };
  
  const handleDetailChange = (key, value) => {
	setPropertyDetails((prevDetails) => ({
	  ...prevDetails,
	  [key]: value,
	}));
  };
  
  const setDetailsFromUnit = (unit, setPropertyDetails) => {
	console.log(unit);
	if (unit) {
	  const { bedrooms, baths, sq_ft, key, floor } = unit;
  
	  setPropertyDetails((prevDetails) => ({
		...prevDetails,
		bedrooms: bedrooms > -1 ? bedrooms : "",
		baths: baths > -1 ? baths : "",
		sq_ft: sq_ft > 10 ? sq_ft : "",
		customPrice: "", // Reset custom price when selecting a unit
		monthlyCC: "",
		monthlyTax: "",
		key: key || "",
		floor: floor || "",
		property: unit || Object.assign({}, selectedBuilding, {address_2_normalized:userAddedUnit})
	  }));
	  fetchListingData(unit); 
	} else {
	  setPropertyDetails({
		bedrooms: "",
		baths: "",
		sq_ft: "",
		customPrice: "",
		monthlyCC: "",
		monthlyTax: "",
		key: "",
		floor: "",
		property: Object.assign({}, selectedBuilding, {address_2_normalized:userAddedUnit}),
		tone: "neutral",
		length: 400,
		highlights:false
	  });
	  setBuildingListing(null);
	  setListing(null);
	  setAIExtractionProgress(true);
	}
  };
  
  const reset = () => {
	clearTags();
	setSelectedBuilding(null);
	setUnits(false);
	setPropertyDetails(defaultPropertyDetails);
	setSelectedUnit("");
	setUserAddedUnit("");
	setAIExtractionProgress(true);
	
  };
  
  useEffect(() => {
	const building = searchTags.filter(item => item.type === "building");	  
	if(building.length > 0){
	  setSelectedBuilding(building[0].data);
	} else {
	  setSelectedBuilding(null);
	}
  }, [searchTags]);
  
  useEffect(() => {
	if(selectedBuilding && !selectedUnit){
	  fetchUnits();
	}
  }, [selectedBuilding]);
  

  
  useEffect(() => {
	setCompSettings({ selectedBuilding, selectedUnit, propertyDetails });
  }, [propertyDetails]);
  
  useEffect(() => {
	return () => {
	  console.log("ListingDescSelector unmounted");
	};
  }, []);
  
  
  const fetchBuilding = async () => {
	  const addressQ = selectedBuilding.alternate_addresses.join('" OR "');
	  let q = `alternate_addresses:("${addressQ}") AND (zip:${selectedBuilding.zip} OR borough:"${selectedBuilding.borough.toLowerCase()}")`;
	 
	  const fq = [
		`deleted:false`,
	  ];
	  let axiosData = {
		url: apiURL + "/query/we3-buildings?cache=1440",
		method: "post",
		query: {
		  q: q,
		  wt: "json",
		  fl: "key,display_full_street_address,name,geocode,borough,neighborhood,markets_major,zip,floors,inventory_total,year_built,year_converted,building_service_level,building_access,amenities_health,ownership_type,sq_ft,total_units,building_style",
		  fq: fq,
		  rows: 999,
		},
	  };
	  let tableData = await _axiosCall(axiosData);
	
	  if(tableData){
		if(tableData.docs && tableData.docs[0]){
			setBuilding(tableData.docs[0]);
			
			return tableData.docs[0];
		}else{
			return false;
		}
		
	  }
	  return false;
	};
  const fetchUnits = async () => {
	const addressQ = selectedBuilding.alternate_addresses.join('" OR "');
	let q = `alternate_addresses:("${addressQ}") AND (zip:${selectedBuilding.zip} OR borough:"${selectedBuilding.borough.toLowerCase()}")`;
	let statsQ = "";
	
	let isCoop = _isCoop(selectedBuilding);
	let isHouse = _isHouse(selectedBuilding);
	
	if (!isHouse) {
	  if (["active"].indexOf(selectedBuilding.offering_verified_status) >= 0) {
		statsQ = `((offering_verified_status:active AND source_organizations:(CDEC NYAG ADEC) AND baths:[1 TO *]) OR verification_source:(user-verified-valid CDEC ADEC))`;
		q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}))`;
	  } else if (
		selectedBuilding.cdec_date &&
		parseInt(moment(selectedBuilding.cdec_date).format("YYYY")) > 1970 &&
		!isCoop
	  ) {
		let unitSource = "source_organizations:(CDEC ADEC)";
		if (
		  selectedBuilding.cdec_units_properties <
		  selectedBuilding.inventory_total * 0.8
		) {
		  unitSource = `(source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}))`;
		}
		statsQ = `(${unitSource} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*) AND -property_type:*commercial* AND -property_type:*multi*)`;
		q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active "in contract")))`;
	  } else if (
		["coming soon"].indexOf(selectedBuilding.offering_verified_status) >= 0
	  ) {
		statsQ = `(source_organizations:NYAG AND offering_baths:[1 TO *] AND offering_price:* AND -offering_file_number:"")`;
		q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active "in contract")))`;
	  } else if (!isCoop) {
		q += ` AND (source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}) OR (current_status:(active "in contract")))`;
	  }
	}
	const fq = [
	  `deleted:false`,
	  `${isHouse ? "" : "-address_2_normalized:\"\""}`,
	  `${isHouse ? "" : "(property_type:(*residential*condo* *bulk*condo* condo *co-op* \"condo unit\" \"resident manager unit\" *coop* *affordable* \"\" *dwelling* *timeshare* *residential* *apartment*))"}`
	];
	let axiosData = {
	  url: apiURL + "/query/we3-properties?cache=60",
	  method: "post",
	  query: {
		q: q,
		sort: "address_2_normalized asc",
		wt: "json",
		"fl": [
		  "full_street_address",
		  "display_full_street_address",
		  "alternate_addresses",
		  "zip",
		  "address_2",
		  "address_2_normalized",
		  "floor",
		  "bedrooms",
		  "baths",
		  "half_baths",
		  "sq_ft",
		  "exterior_sq_ft",
		  "offering_price",
		  "building",
		  "building_name",
		  "neighborhood",
		  "borough",
		  "monthly_fees",
		  "monthly_taxes",
		  "key",
		  "total_units",
		  "residential_units",
		  "last_sold_price",
		  "last_sold_date",
		  "price",
		  "last_listed_sale_price_all",
		  "last_listed_sale_date_all",
		  "last_listed_sale_modified_date_all",
		  "last_listed_sale_ppsf_all",
		  "last_listed_rent_price_all",
		  "last_listed_rent_date_all",
		  "last_contract_date",
		  "last_contract_price",
		  "last_contract_date_formatted",
		  "last_listed_sale_key_all",
		  "last_listed_rent_key_all",
		  "last_listed_sale_status_all",
		  "last_listed_rent_status_all",
		  "id",
		  "div(last_sold_price, sq_ft)",
		  "div(last_listed_sale_price_all, sq_ft)",
		  "div(last_contract_price, sq_ft)",
		  "div(sub(offering_price, last_listed_sale_price_all), offering_price)",
		  "div(sub(offering_price, last_sold_price), offering_price)",
		  "owner",
		  "ownership_type",
		  "borough_code",
		  "block",
		  "lot",
		  "year*",
		  "building_class",
		  "property_features",
		  "building_features",
		  "floor",
		  "last_listed_sale_price_all",
		  "last_listed_sale_ppsf_all",
		  "last_listed_sale_date_all",
		  "last_sold_price",
		  "last_sold_date",
		  "offering_price",
		  "offering_submitted_date",
		  "offering_reviewed_date",
		  "offering_accepted_date",
		  "offering_effective_date",
		  "property_status",
		  "last_listed_sale_key_all",
		  "last_listed_sale_key_all"
		],
		fq: fq,
		rows: 999,
	  },
	};
	let tableData = await _axiosCall(axiosData);
  
	if(tableData){
	  if(isHouse){
		  if(tableData.docs && tableData.docs[0]){
			  let building = await fetchBuilding();
			  let unit = tableData.docs[0];
			  if(unit.sq_ft < 100 && building.sq_ft > 100){
				  unit.sq_ft = building.sq_ft;
			  }
			  setSelectedUnit(tableData.docs[0]);
			  setDetailsFromUnit(tableData.docs[0], setPropertyDetails);
			  setUserAddedUnit(null);
			  
		  }
		  setUnits(false);
	  }else{
		  setUnits(tableData.docs || []);
	  }
	  
	}
  };
  
  const extractFeatures = async () => {
  	setAIExtractionProgress(true);

  
	let prompt = `The following is a real estate listing description from a random unit in a building. Extract only the in-unit appliances and finishes that are common to all units in this building, ignore any that indicates renovation. Extract only the top 20 as a distinct list of property feature keywords in csv format, format each value with property capitalization. Do not include anything else, no headers not other formatting. Extract only neutral, factual property or listing features suitable for public marketing materials. Reword any features that could violate fair housing standards or imply preference, bias, or discrimination. Do not include politically sensitive or racially sensitive words. Use inclusive, neutral terminology (for example, say “primary bedroom” instead of “master bedroom”). If a feature description cannot be expressed neutrally, omit it.`;
  
	if (building && building.building_status !== "sponsor") {
	  prompt = `The following is a real estate listing description from a random unit in a building. Extract only amenities and finishes that are common to all units in this building, ignore any in-unit features. Extract only the top 20 as a distinct list of property feature keywords in csv format, format each value with property capitalization. Do not include anything else, no headers not other formatting.  Extract only neutral, factual property or listing features suitable for public marketing materials. Reword any features that could violate fair housing standards or imply preference, bias, or discrimination. Do not include politically sensitive or racially sensitive words. Use inclusive, neutral terminology (for example, say “primary bedroom” instead of “master bedroom”). If a feature description cannot be expressed neutrally, omit it.`;
	}
  
	prompt += " Don’t justify your answers. Use facts.";
  
	if (listing && listing.description && listing.description.length > 50) {
	  prompt += `\n\n<<INPUT>>\n"${listing.description}"`;
	} else if (buildingListing && buildingListing.description && buildingListing.description.length > 50) {
	  prompt += "Ignore outdoor space.  Ignore number of bedrooms.  Ignore number of baths.  Ignore size of the unit.\n\n";
	  prompt += `\n\n<<INPUT>>\n"${buildingListing.description}"`;
	} else {
	  setPropertyDetails((prev) => ({ ...prev, aiExtractionProgress: false }));
	  return;
	}
  
	const queryData = {
	  messages: [
		{ role: "system", content: "You are a real estate agent." },
		{ role: "user", content: prompt }
	  ],
	  model: "gpt-4.1-mini"
	};
  
	try {
	  const res = await fetch(apiURL + "/ai/chat", {
		method: "POST",
		headers: {
		  Accept: "application/json",
		  "Content-Type": "application/json"
		},
		body: JSON.stringify(queryData)
	  });
  
	  const json = await res.json();
	  if (json && json.choices && json.choices[0] && json.choices[0].message && json.choices[0].message.content) {
		const raw = json.choices[0].message.content;

		const highlights = raw
		  .split(",")
		  .map((item) => {
			let str = item.trim();
			const i = str.indexOf(":");
			if (i !== -1) str = str.substring(i + 1).trim();
			return str.replace(/undefined/g, "").replace(/"/g, "").trim();
		  })
		  .filter((item) => item !== "");
  
		if (highlights.length > 0) {
		  handleDetailChange("highlights", highlights);
		}
	  }
	} catch (err) {
	  console.error("AI extraction failed:", err);
	}
  
	setAIExtractionProgress(false);
  };

  const _getListingData = async (listingKey, property) => {
	const q = `key:${listingKey.replace("REBNY-LISTING-", "*").replace("REBNY-VOW-", "REBNY-IDX-")}`;
	const axiosData = {
	  url: apiURL + "/query/search-listings?cache=15",
	  method: "post",
	  query: {
		q: q,
		sort: "solr_updated_date desc",
		wt: "json",
		rows: 10
	  }
	};
  
	try {
	  const res = await _axiosCall(axiosData);
	  if (res.docs && res.docs.length > 0 && res.docs[0].description && res.docs[0].description.length>100) {
		setListing(res.docs[0]);
	  } else {
		setListing(false);
		_getBuildingListingData(property);
	  }
	} catch (err) {
	  console.log("error:", err);
	  setListing(false);
	}
  };
  
  const _getBuildingListingData = async (property) => {
	const q = `(alternate_addresses:("${property.alternate_addresses.join('" OR "')}") AND zip:${property.zip})`;
	const axiosData = {
	  url: apiURL + "/query/search-listings?cache=15",
	  method: "post",
	  query: {
		q: q,
		fl: ["description"],
		fq: ["deleted:false", "listing_type:sale"],
		sort: "sale_status asc, listing_date desc",
		wt: "json",
		rows: 5
	  }
	};
  
	try {
	  const res = await _axiosCall(axiosData);
	  if (res.docs && res.docs.length > 0) {
		let best = res.docs[0];
		res.docs.forEach((l) => {
		  if (l.description && l.description.length > best.description.length) {
			best = l;
		  }
		});
		setListing(false);
		setBuildingListing(best);
	  } else {
		setListing(false);
		setBuildingListing(false);
	  }
	} catch (err) {
	  console.log("error:", err);
	  setListing(false);
	  setBuildingListing(false);
	}
  };
  
  const fetchListingData = async (property) => {
	  
	  console.log("here", property)
	if (!property) return;
  
	const isActive = property.offering_status === "active";
	const hasRent = property.last_listed_rent_key_all;
	const hasSale = property.last_listed_sale_key_all;
	const rentIsActive = property.last_listed_rent_status_all === "active";
	const saleIsActive = property.last_listed_sale_status_all === "active";
  
	if (isActive || hasRent || hasSale) {
	  if (hasSale && !(rentIsActive && !saleIsActive)) {
		await _getListingData(property.last_listed_sale_key_all, property);
	  } else if (hasRent) {
		await _getListingData(property.last_listed_rent_key_all, property);
	  } else {
		await _getBuildingListingData(property);
	  }
	} else {
	  await _getBuildingListingData(property);
	}
  };


  useEffect(() => {
	  
	  console.log(listing, buildingListing)
	if (
	  (listing && listing.description && listing.description.length > 50) ||
	  (buildingListing && buildingListing.description && buildingListing.description.length > 50)
	) {
	  extractFeatures();
	}else{
		setAIExtractionProgress(false);
	}
  }, [listing, buildingListing]);
  
  
  useEffect(() => {
	if(userAddedUnit){
	  setAIExtractionProgress(false);
	}
  }, [userAddedUnit]);


  // Disable the "Generate Report" button if any required field is empty
  const isReportDisabled = propertyDetails.bedrooms === "" ||
						   propertyDetails.baths === "" ||
						   aiExtractionProgress
  
  return (
	  <div className="property-selector-container">
		<h2 className="property-selector-heading">Generate a Listing Description</h2>
		<hr className="property-selector-spacer" />
  
		<div className="property-selector-section">
		  <div className="property-selector-step">1</div>
		  <div className="property-selector-text">
			<h3>Choose a Property</h3>
			<div className="property-selector-subtext">Enter an address or building name (no unit), then select a unit if applicable.</div>
		  </div>
		</div>
  
		<div className="property-selector-row">
		 
		  <GeneralBuildingSearchBar
			buildingFilter={
			  '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
			}
			handleSearch={(building) => {
			  console.log(building);
			  handleBuildingSelect(building);
			}}
			condoCoopOnly={false}
			buildingAttributes={[]}
			placeHolder={"Address or Building Name"}
			addBuilding={false}
			buildingTab={null}
			hideBoroHood={true}
			hideAddIcon={true}
			hideMapDraw={true}
			searchBarStyles={searchBarBuildingStyles}
			exitMessageData={{
			  title: "Report Unavailable",
			  message:
				"Comp reports are currently available for condos, co-ops and townhouses. Click continue if you would like to learn more about this property on our public website.",
			}}
			className="internal-search"
		  />
		  
		  {/* Unit selector */}
		  {units || (selectedUnit && typeof selectedUnit == "string") ? 
			<Autocomplete
			  options={
				(userAddedUnit &&
				!(units || []).some(function (item) {
				  return (
					item.address_2_normalized.toUpperCase() === userAddedUnit.toUpperCase() ||
					item.address_2_normalized.toUpperCase().replace("APT ", "") === userAddedUnit.toUpperCase()
				  );
				})
				? ['Add ' + userAddedUnit + '']
				: []
			  ).concat(units || []).map(function (item) {
				if (typeof item === "string") return item;
				return item.address_2_normalized.toUpperCase().replace("APT", "Apt");
			  })}
			  getOptionLabel={function (option) {
				if (option.indexOf("Add") === 0) return option;
				return option || "";
			  }}
			  freeSolo
			  value={
				selectedUnit && typeof selectedUnit == "string"
				  ? selectedUnit.toUpperCase().replace("APT", "Apt")
				  : null
			  }
			  inputValue={userAddedUnit || ""}
			  onInputChange={function (event, newInputValue) {
				console.log("onInputChange", newInputValue);
				if(newInputValue && newInputValue.indexOf("Add") === 0){
				  setUserAddedUnit(newInputValue.trim().replace("Add ", ""));
				} else {
				  setUserAddedUnit(newInputValue || "");
				}
			  }}
			  onKeyDown={function (event) { 
				if (event.key === "Enter") {
				  console.log("onKeyDown", userAddedUnit, selectedUnit);
				  if(userAddedUnit !== selectedUnit){
					handleUnitSelect(userAddedUnit);
				  }
				}
			  }}
			  onChange={function (event, newValue) {
				console.log("onChange", newValue);
				if (newValue && newValue.indexOf("Add") === 0) {
				  var newUnit = userAddedUnit.trim().replace("Add ", "");
				  setSelectedUnit(newUnit);
				  setUserAddedUnit(null);
				  setDetailsFromUnit(false, setPropertyDetails);
				} else if (
				  (units || []).some(function (item) {
					return (
					  item.address_2_normalized.toUpperCase() ===
					  (newValue ? newValue.toUpperCase() : "")
					);
				  })
				) {
				  handleUnitSelect(newValue);
				} else {
				  setSelectedUnit("");
				  setUserAddedUnit(null);
				}
			  }}
			  renderOption={function (option) {
				if (option.indexOf("Add") === 0) {
				  return (
					<React.Fragment>
					  <div style={{ fontWeight: "bold", color: "#333", borderBottom: "1px solid #ddd", paddingBottom:10, paddingTop:10, width:"100%" }}>
						{option}
					  </div>
					  <hr style={{ margin: "4px 0", borderTop: "1px solid #ddd" }} />
					</React.Fragment>
				  );
				}
				return <div>{option}</div>;
			  }}
			  renderInput={function (params) {
				return (
				  <TextField
					{...params}
					placeholder="Select or Add Unit"
					variant="outlined"
					InputProps={{
					  ...params.InputProps,
					  classes: {
						root: classes.outlinedTextField,
						input: classes.inputInput,
					  },
					}}
					style={{marginLeft:20}}
				  />
				);
			  }}
			/>
		  : null}
		</div>
  
		{selectedUnit && (
		  <div>
			<hr />
			<div className="property-selector-section">
			  <div className="property-selector-step">2</div>
			  <div className="property-selector-text">
				<h3>{isReportDisabled ? "Add Details for the Property" : "Confirm Property Details"}</h3>
				<div className="property-selector-subtext">
				  {isReportDisabled
					? "Add info about property size and asking price"
					: "Double check property info and add an asking price"}
				</div>
			  </div>
			</div>
  
			<div className="property-selector-flex">
			  <TextField
				required
				error={propertyDetails.bedrooms === ""}
				variant="outlined"
				placeholder="Bedrooms"
				label="Bedrooms"
				value={propertyDetails.bedrooms}
				onChange={(e) => /^\d*\.?\d*$/.test(e.target.value) && handleDetailChange("bedrooms", e.target.value)}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInput,
				  },
				}}
				helperText="(Required)"
			  />
			  <TextField
				required
				error={propertyDetails.baths === ""}
				variant="outlined"
				placeholder="Bathrooms"
				label="Bathrooms"
				value={propertyDetails.baths}
				onChange={(e) => /^\d*\.?\d*$/.test(e.target.value) && handleDetailChange("baths", e.target.value)}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInput,
				  },
				}}
				helperText="(Required)"
			  />
			  <TextField
				required
				variant="outlined"
				placeholder="Square Foot"
				label="Square Foot"
				value={formatCurrencyLive(propertyDetails.sq_ft, "")}
				onChange={(e) => {
				  let raw = e.target.value.replace(/[^0-9.]/g, "");
				  const parts = raw.split(".");
				  if (parts.length > 2) raw = parts[0] + "." + parts.slice(1).join("");
				  handleDetailChange("sq_ft", raw);
				}}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInput,
				  },
				}}
				helperText="(Optional)"
			  />
			  <TextField
				variant="outlined"
				placeholder="List Price"
				label="List Price"
				value={formatCurrencyLive(propertyDetails.customPrice)}
				onChange={(e) => {
				  let raw = e.target.value.replace(/[^0-9.]/g, "");
				  const parts = raw.split(".");
				  if (parts.length > 2) raw = parts[0] + "." + parts.slice(1).join("");
				  handleDetailChange("customPrice", raw);
				}}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInputLong,
				  },
				}}
				helperText="(Optional)"
			  />
			  {selectedBuilding && !_isHouse(selectedBuilding) ?
			  <TextField
				  variant="outlined"
				  placeholder={_isCoop(selectedBuilding) ? "Monthly Maintenance" : "Monthly CC"}
				  label={_isCoop(selectedBuilding) ? "Monthly Maintenance" : "Monthly CC"}
				  value={formatCurrencyLive(propertyDetails.monthlyCC)}
				  onChange={(e) => {
					let raw = e.target.value.replace(/[^0-9.]/g, "");
					const parts = raw.split(".");
					if (parts.length > 2) raw = parts[0] + "." + parts.slice(1).join("");
					handleDetailChange("monthlyCC", raw);
				  }}
				  InputProps={{
					classes: {
					  root: classes.outlinedTextField,
					  input: classes.inputInputLong,
					},
				  }}
				  helperText="(Optional)"
				/> : null}
				
				{selectedBuilding && !_isCoop(selectedBuilding) ?
				<TextField
					variant="outlined"
					placeholder="Monthly Tax"
					label="Monthly Tax"
					value={formatCurrencyLive(propertyDetails.monthlyTax)}
					onChange={(e) => {
					  let raw = e.target.value.replace(/[^0-9.]/g, "");
					  const parts = raw.split(".");
					  if (parts.length > 2) raw = parts[0] + "." + parts.slice(1).join("");
					  handleDetailChange("monthlyTax", raw);
					}}
					InputProps={{
					  classes: {
						root: classes.outlinedTextField,
						input: classes.inputInputLong,
					  },
					}}
					helperText="(Optional)"
				  />:null}
			</div>
  
			<hr />
  
			{propertyDetails.bedrooms !== "" && propertyDetails.baths !== "" ? (
			  <>
				<div className="property-selector-section">
				  <div className="property-selector-step">3</div>
				  <div className="property-selector-text">
					<h3>Adjust Preferences</h3>
					<div className="property-selector-subtext">Adjust the tone or customize the length of your listing description. (Optional)</div>
				  </div>
				</div>
  
				<div className="property-selector-photo-upload">
				  <LengthSlider value={propertyDetails.length} onChange={(val) => { handleDetailChange("length", val ) }} />
				  <ToneSelector value={propertyDetails.tone} onChange={(val) =>  { handleDetailChange("tone", val )}} />

				</div>
				<hr />
				<div className="property-selector-section">
				  <div className="property-selector-step">4</div>
				  <div className="property-selector-text">
					<h3>Highlight Features</h3>
					<div className="property-selector-subtext">Highlight unique characterstics about this unit, e.g. interior finishes, brand of appliances, views. (Optional)</div>
				  </div>
				</div>
				
				{(aiExtractionProgress) ?
					<LinearLoading />
					:
					<div className="property-selector-photo-upload">
					<br/>
				  	<FormAutocompleteSelect
						value={propertyDetails.highlights ? propertyDetails.highlights : []}
						onChange={(val) => handleDetailChange("highlights", val)}
						placeholder="Add a feature"
						label="Additional Features"
						helperText="Describe finishes, appliances, or views"
				  	/>
					
					</div>
				}
				<hr />
			  </>
			):null}
  
			<div className="property-selector-button-row">
			  <Tooltip title="Generate Comp Report with Selected Subject Property">
				<span>
				  <Button
					startIcon={<TextIcon />}
					className={classes.searchButton}
					onClick={updateBuildingReport}
					disabled={isReportDisabled}
				  >
					Generate Description
				  </Button>
				</span>
			  </Tooltip>
			  <Tooltip title="Reset Subject Property">
				<Button className={classes.resetButton} onClick={reset}>
				  Reset
				</Button>
			  </Tooltip>
			</div>
		  </div>
		)}
	  </div>
	);
}
